import { render } from "./IconBalance.vue?vue&type=template&id=a4d734c8&scoped=true&ts=true"
import script from "./IconBalance.vue?vue&type=script&lang=ts"
export * from "./IconBalance.vue?vue&type=script&lang=ts"

import "./IconBalance.vue?vue&type=style&index=0&id=a4d734c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d734c8"]])

export default __exports__